export const Signature = (() => {

    let canvas;
    let context;
    let draw = false;
    let mouse = { x: 0, y: 0 };
    const sensitivity = 0.0035;

    const calculateCoordinates = (event) => {

        let ClientRect = canvas.getBoundingClientRect();
        mouse.x = (event.clientX - ClientRect.left) * (canvas.width/ClientRect.width);
        mouse.y = (event.clientY - ClientRect.top) * (canvas.height/ClientRect.height);
    }

    const mouseDownListener = () => {
        canvas.addEventListener("mousedown", function(e) {
            calculateCoordinates(e);
            draw = true;
            context.beginPath();
            context.moveTo(mouse.x, mouse.y);
        });
        canvas.addEventListener("touchstart", function(e){
            let touch = e.touches[0]
            let mouseEv = new MouseEvent('mousedown',{
                clientX:touch.clientX,
                clientY:touch.clientY
            })
            canvas.dispatchEvent(mouseEv)
        })
    }

    const mouseUpListener = () => {
        canvas.addEventListener("mouseup", function(e) {
            calculateCoordinates(e);
            context.lineTo(mouse.x, mouse.y);
            context.stroke();
            context.closePath();
            draw = false;
        });
        canvas.addEventListener("touchend", function(e){
            let touch = e.touches[0]
            let mouseEv = new MouseEvent('mouseup',{
                clientX:touch.clientX,
                clientY:touch.clientY
            })
            canvas.dispatchEvent(mouseEv)
        })
    }

    const mouseMoveListener = () => {
        canvas.addEventListener("mousemove", function(e) {
            if(draw === true){
                calculateCoordinates(e);
                context.lineTo(mouse.x, mouse.y);
                context.stroke();
            }
        });
        canvas.addEventListener("touchmove", function(e){
            let touch = e.touches[0]
            let mouseEv = new MouseEvent('mousemove',{
                clientX:touch.clientX,
                clientY:touch.clientY
            })
            canvas.dispatchEvent(mouseEv)
        })
    }

    const blockScrollingListener = () =>{
        const stopCb = (e)=>{
            if(e.target == canvas) 
                e.preventDefault()
        }
        document.body.addEventListener('touchstart', e=>stopCb(e))
        document.body.addEventListener('touchend', e=>stopCb(e))
        document.body.addEventListener('touchmove', e=>stopCb(e))
    }

    const clearListner = () => {
        document.querySelector('#clear-signature').addEventListener('click', function() {
            context.clearRect(0, 0, canvas.width, canvas.height);
        })
    }

    const defaultListners = () => {
        mouseMoveListener();
        mouseDownListener();
        mouseUpListener();
        blockScrollingListener();
        clearListner();
    }

    return class Signature {

        constructor(containerId='signature-container', width=670, height=190) {
            this.container = document.querySelector(`#${containerId}`);
            this.sourceSignature = this.container.querySelector('input[name="signature"]');

            canvas = this.container.querySelector('canvas');

            if (canvas) {
                canvas.width = width;
                canvas.height = height;
                context = canvas.getContext('2d');
                context.strokeStyle = "black";
                defaultListners();
            }
        }

        getSignatureData() {
            const canvas = this.container.querySelector('canvas');
            return canvas ? (this.checkEmptySignature(canvas) ? canvas.toDataURL() : false) : this.container.querySelector('img').src;
        }

        checkEmptySignature(canvas){
            const ctx = canvas.getContext('2d');
            const imgData = ctx.getImageData(0,0,canvas.width, canvas.height).data
            const fillPixels = (imgData.filter((el,i)=>(i+1)%4==0 && el!=0).length) / (imgData.length/4)
            return fillPixels>sensitivity
        }

        static drawIn(containerId='signature-container', options={}) {
            return new Signature(containerId, options.width ?? 670, options.height ?? 190);
        }

        static defaultSignature() {
            return document.querySelector('img#signature-img').src;
        }

        static init(customerHasSignature, options={}) {
            if (customerHasSignature) {
                return () => Signature.defaultSignature();
            } else {
                const signature = Signature.drawIn('signature-container', options);
                return () => {
                    return signature.getSignatureData();
                }
            }
        }
    }

})();


